import { get } from "@rails/request.js";

// Slow-fill warning under the state picker on the Realtime order page (#16834).
// The server (LeadFlow::FillForecast via /realtime_lead_orders/fill_forecast)
// decides the verdict and writes the sentence: days, the fill goal and state
// codes only — never a lead count or another order. This module only builds
// the query and paints the box; it never computes a forecast itself.

const DANGER_VERDICTS = ["very_slow", "no_flow"];

// Rails array params (states[], days_per_week[]) and blank-free scalars.
export function fillForecastQuery({ leadClass, quality, quantity, states, days, maxPerDay, windowStart, windowEnd }) {
  const query = new URLSearchParams();
  query.append("lead_class", leadClass || "");
  query.append("quality", quality || "");
  query.append("quantity", String(quantity || ""));
  (states || []).forEach((state) => query.append("states[]", state));
  (days || []).forEach((day) => query.append("days_per_week[]", day.toLowerCase()));
  if (maxPerDay) query.append("max_per_day", String(maxPerDay));
  if (windowStart && windowEnd) {
    query.append("delivery_window_start", windowStart);
    query.append("delivery_window_end", windowEnd);
  }
  return query;
}

export async function fetchFillForecast(url, query) {
  const response = await get(url, { query, responseKind: "json" });
  if (!response.ok) throw new Error(`fill_forecast ${response.statusCode}`);
  return response.json;
}

// host: the wrapper; it holds one .gl-alert, a message node
// ([data-fill-forecast-message]), the restriction choice buttons
// ([data-fill-forecast-actions]) and the kept note ([data-fill-forecast-kept]).
// Hidden unless the forecast warns. Slow states WITH delivery restrictions show
// the restrictions sentence and its Yes / No buttons (owner 2026-10-13).
export function renderFillForecast(host, data, { restrictionsKept = false } = {}) {
  if (!host) return;
  const warn = Boolean(data?.warn && data.message);
  host.classList.toggle("d-none", !warn);
  if (!warn) return;
  const restricted = Boolean(data.restrictions_warning && data.restrictions_message);
  host.querySelector("[data-fill-forecast-actions]")?.classList.toggle("d-none", !restricted || restrictionsKept);
  host.querySelector("[data-fill-forecast-kept]")?.classList.toggle("d-none", !restricted || !restrictionsKept);

  const alert = host.querySelector(".gl-alert");
  const danger = DANGER_VERDICTS.includes(data.verdict);
  alert?.classList.toggle("gl-alert--danger", danger);
  alert?.classList.toggle("gl-alert--warning", !danger);
  const message = host.querySelector("[data-fill-forecast-message]");
  if (message) message.textContent = restricted ? data.restrictions_message : data.message;
}
